import { z } from 'zod';

const requiredStringSchema = z.string().min(1);

export const vesselSchema = z.object({
  Id: requiredStringSchema,
  Name: requiredStringSchema
});

export const vesselArraySchema = z.array(vesselSchema);

export const vesselArrayApiResponseSchema = z.object({
  Data: vesselArraySchema
});

export type Vessel = z.infer<typeof vesselSchema>;
export type VesselArray = z.infer<typeof vesselArraySchema>;
export type VesselArrayApiResponse = z.infer<typeof vesselArrayApiResponseSchema>;
